'use client'

import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 768
const LARGE_DESKTOP_BREAKPOINT = 1080

export type ViewportTier = 'mobile' | 'medium' | 'large'

/**
 * Reporta o tier de viewport atual (mobile / medium-desktop / large-desktop).
 *
 * - `mobile` < 768px
 * - `medium` 768-1079px
 * - `large` >= 1080px
 *
 * Default em SSR/primeiro render: `large` (mais permissivo — evita hide flicker
 * de UI rica em desktop). useEffect corrige após hidratação.
 */
export function useViewportTier(): ViewportTier {
  const [tier, setTier] = useState<ViewportTier>('large')

  useEffect(() => {
    const compute = (): ViewportTier => {
      const w = window.innerWidth
      if (w < MOBILE_BREAKPOINT) return 'mobile'
      if (w < LARGE_DESKTOP_BREAKPOINT) return 'medium'
      return 'large'
    }
    const onChange = () => setTier(compute())
    setTier(compute())

    const mqlMobile = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const mqlLarge = window.matchMedia(`(min-width: ${LARGE_DESKTOP_BREAKPOINT}px)`)
    mqlMobile.addEventListener('change', onChange)
    mqlLarge.addEventListener('change', onChange)
    return () => {
      mqlMobile.removeEventListener('change', onChange)
      mqlLarge.removeEventListener('change', onChange)
    }
  }, [])

  return tier
}
